import { useEffect, useState } from 'react'
import { Check } from 'lucide-react'
import { toast } from 'sonner'
import Modal from './ui/Modal'
import Button from './ui/Button'
import { produtividade } from '../utils/api'

export default function ChangelogModal({ open, onClose }) {
  const [novidades, setNovidades] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const load = async () => {
    setLoading(true)
    setError('')
    try {
      const { data } = await produtividade.centro()
      setNovidades(data?.novidades || [])
    } catch {
      setError('Não foi possível carregar as novidades.')
    } finally {
      setLoading(false)
    }
  }
  
  useEffect(() => {
    if (open) {
      void load()
    }
  }, [open])

  return (
    <Modal open={open} onClose={onClose} title="Novidades da Plataforma" size="md">
      <div className="flex flex-col gap-4">
        {loading ? <p role="status" className="text-sm">Carregando novidades…</p> : error ? (
          <div role="alert"><p className="text-sm">{error}</p><Button onClick={load} size="sm">Tentar novamente</Button></div>
        ) : novidades.length === 0 ? (
          <p className="text-sm" style={{color: 'var(--text3)'}}>Nenhuma novidade recente para o seu perfil.</p>
        ) : (
          novidades.map(item => (
            <div key={item.id} className="p-3 border rounded-md" style={{borderColor: 'var(--border)'}}>
              <div className="flex justify-between items-start mb-1">
                <strong className="text-sm">{item.titulo}</strong>
                <small style={{color: 'var(--text3)'}}>v{item.versao}</small>
              </div>
              <p className="text-sm mb-2" style={{color: 'var(--text2)'}}>{item.resumo}</p>
              {!item.lida ? (
                <Button size="sm" variant="outline" onClick={async () => {
                  try {
                    await produtividade.marcarNovidade(item.id)
                    setNovidades(prev => prev.map(n => n.id === item.id ? { ...n, lida: true } : n))
                  } catch {
                    toast.error('Não foi possível marcar a novidade como lida.')
                  }
                }}>Marcar como lida</Button>
              ) : (
                <span className="flex items-center gap-1 text-xs" style={{color: 'var(--success)'}}><Check size={14}/> Lida</span>
              )}
            </div>
          ))
        )}
      </div>
    </Modal>
  )
}
